// Own the SDK lifecycle rather than clipping or scaling the contents of an ad.
export function createAdController({boundary,target,blockId,type,minWidth=160,maxHeight=null,env=globalThis}){
 let enabled=false,disposed=false,queued=false,requested=false,generation=0;
 let requestWidth=0,lastWidth=0,timer=null,frame=null;
 const width=()=>boundary.getBoundingClientRect().width;
 const state=value=>{boundary.dataset.adFit=value;};
 const clearTimer=()=>{if(timer!==null)env.clearTimeout(timer);timer=null;};
 function destroy(){
  generation++;queued=false;
  if(requested){
   const manager=env.window.Ya?.Context?.AdvManager;
   if(typeof manager?.destroy!=='function')return false;
   try{manager.destroy({blockId});}catch{return false;}
   requested=false;target.replaceChildren();delete target.dataset.rtbRendered;
  }
  return true;
 }
 function enqueue(){
  if(disposed||!enabled||queued||requested||width()+.5<minWidth)return;
  queued=true;const current=++generation;
  env.window.yaContextCb=env.window.yaContextCb||[];
  env.window.yaContextCb.push(()=>{
   if(disposed||!enabled||current!==generation||!target.isConnected)return;
   queued=false;
   if(width()+.5<minWidth){state('waiting-width');return;}
   const manager=env.window.Ya?.Context?.AdvManager;
   if(!manager||target.dataset.rtbRendered==='true')return;
   requestWidth=width();requested=true;state('checking');
   target.dataset.rtbState='requested';target.dataset.rtbBlockId=blockId;
   target.dataset.rtbRendered='true';
   try{manager.render({blockId,renderTo:target.id,...(type?{type}:{}),
    onRender:()=>{if(!disposed&&current===generation&&target.isConnected){target.dataset.rtbState='rendered';inspect();}},
    onError:error=>{if(!disposed&&current===generation&&target.isConnected){target.dataset.rtbState='error';target.dataset.rtbError=String(error?.code??'unknown').slice(0,80);inspect();}}
   });}catch{target.dataset.rtbState='error';state('unavailable');}
   scheduleInspect();
  });
 }
 function renderAfterResize(){
  clearTimer();state('resizing');
  timer=env.setTimeout(()=>{timer=null;enqueue();},600);
 }
 function inspect(){
  if(disposed||!enabled)return;
  const available=width();
  if(available+.5<minWidth){state('waiting-width');return;}
  if(timer!==null)return;
  if(!requested){enqueue();return;}
  // Make a previously suppressed creative measurable; it stays invisible until checked.
  state('checking');
  const box=target.getBoundingClientRect();
  const overflow=target.scrollWidth>box.width+2||(maxHeight&&Math.max(box.height,target.scrollHeight)>maxHeight+2);
  if(!overflow){state('fits');return;}
  if(Math.abs(available-requestWidth)>2&&destroy())renderAfterResize();
  else state('unavailable'); // Never expose an oversized creative or retry the same size in a loop.
 }
 function scheduleInspect(){
  if(disposed||frame!==null)return;
  frame=env.requestAnimationFrame(()=>{frame=null;inspect();});
 }
 const resize=new env.ResizeObserver(()=>{
  const current=width();if(Math.abs(current-lastWidth)<.5)return;lastWidth=current;
  if(timer!==null){renderAfterResize();return;}
  inspect();
 });
 const mutation=new env.MutationObserver(scheduleInspect);
 resize.observe(boundary);mutation.observe(target,{childList:true,subtree:true,attributes:true,attributeFilter:['style','width','height']});
 state('disabled');
 return{
  setDisabled(disabled){
   enabled=!disabled;
   if(disabled){clearTimer();destroy();state('disabled');}
   else inspect();
  },
  dispose(){
   disposed=true;enabled=false;clearTimer();
   if(frame!==null)env.cancelAnimationFrame(frame);
   resize.disconnect();mutation.disconnect();destroy();
  }
 };
}
